import React from "react";
import GraphQLSEOData from "types/seo/graphQLSEOData";

const getSEOFromData = (path: string, data: GraphQLSEOData) => {
  return {
    path: path,
    dateCreated: data.dateCreated,
    dateUpdated: data.dateUpdated,
    author: data.author,
    metaTitle: data.metaTitle,
    metaDescription: data.metaDescription,
    seoImage: data.seoImage[0].seoImageAsset[0],
  };
};

export default getSEOFromData;
